import React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Card, GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Field, FieldArrayRenderProps } from "@progress/kendo-react-form";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormTextField from "../../components/formFields/FormTextField";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { Typography } from "@progress/kendo-react-common";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { setKarigarChargesDeleteIndex } from "./karigarSlice";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { ICharges } from "../charges/chargesModel";
import { findAllActiveCharges } from "../charges/services/charges.services";

const KarigarChargesArray = (fieldArrayRenderProps: FieldArrayRenderProps) => {
  const dispatch = useAppDispatch();
  const KarigarChargesDeleteIndex = useAppSelector(
    (state) => state.karigar.KarigarChargesDeleteIndex,
  );
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const ChargesList = useAppSelector((state) => state.charges.ChargesList);
  const handleDeleteAction = React.useCallback(
    (index: number) => {
      fieldArrayRenderProps.onRemove({ index: index });
      dispatch(closeDialog());
      dispatch(setKarigarChargesDeleteIndex(-1));
    },
    [fieldArrayRenderProps],
  );

  const pushElementInarray = React.useCallback(() => {
    fieldArrayRenderProps?.onPush({
      value: {
        charges_id: null,
        rate: null,
      },
    });
  }, [fieldArrayRenderProps]);

  const handleOpenDeleteDialog = (index: any) => {
    dispatch(openDialog("karigarchargesDeleteDialog"));
    dispatch(setKarigarChargesDeleteIndex(index));
  };

  return (
    <GridLayout cols={[{ width: "100%" }]}>
      {/* {fieldArrayRenderProps?.value?.length <= 0 ? pushElementInarray() : null} */}
      {dialogName === "karigarchargesDeleteDialog" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Karigar Charges Data"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(KarigarChargesDeleteIndex)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
      {fieldArrayRenderProps.value &&
        fieldArrayRenderProps.value.length > 0 &&
        fieldArrayRenderProps.value.map(
          (karigar_charges: any, index: number) => (
            <GridLayoutItem key={index}>
              <Card className="fieldarray-card">
                <GridLayout
                  style={{ marginRight: 45 }}
                  gap={{ rows: 0, cols: 10 }}
                  cols={[{ width: "40%" }, { width: "40%" }, { width: "10%" }]}
                >
                  <GridLayoutItem>
                    <Field
                      name={`karigar_charges.${index}.charges_id`}
                      label="Charges Name"
                      placeholder="Select Charges"
                      component={FormSelectionField}
                      validator={requiredValidator}
                      isAddNew={true}
                      drawerName="chargesForm"
                      dispatcherFunction={findAllActiveCharges}
                      options={ChargesList?.map((item: ICharges) => {
                        return {
                          value: item.id,
                          label: item.charges_name,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name={`karigar_charges.${index}.rate`}
                      label="Rate"
                      placeholder="i.e. 100"
                      type="number"
                      component={FormTextField}
                      validator={requiredValidator}
                      astrike={true}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem
                    style={{
                      marginTop: 42,
                    }}
                  >
                    <Button
                      // style={{ padding: 8, marginLeft: 0 }}
                      onClick={() => handleOpenDeleteDialog(index)}
                      // disabled={fieldArrayRenderProps.value.length === 1}
                      fillMode={"solid"}
                      themeColor={"error"}
                      type="button"
                      size={"small"}
                    >
                      Delete
                    </Button>
                  </GridLayoutItem>
                </GridLayout>
              </Card>
            </GridLayoutItem>
          ),
        )}
      <GridLayoutItem style={{ marginBottom: 10, textAlign: "left" }}>
        <Button
          fillMode={"solid"}
          themeColor={"primary"}
          onClick={pushElementInarray}
          type="button"
        >
          Add Karigar Process
        </Button>
      </GridLayoutItem>
    </GridLayout>
  );
};

export default KarigarChargesArray;
